import React, { useContext, useState } from "react";
import "./My_Account.css";
import Section_Header_Bar from "../../common_components/section_header_bar/Section_Header_Bar";
import { Accordion } from "react-bootstrap";
import Orange_White_Border_Btn from "../../common_components/common_btn/orange_white_border_btn/Orange_White_Border_Btn";
import Blue_White_Gradient_Btn from "../../common_components/common_btn/blue_white_gradient_btn/Blue_White_Gradient_Btn";
import Inner_Footer_Text_Component from "../../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import { useNavigate } from "react-router-dom";
import Change_Trading_Password_Modal from "../../common_components/common_modal/change_trading_password_modal/Change_Trading_Password_Modal";
import { Context } from "../../../utils/context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";

const My_Account = () => {
  const [activeKey, setActiveKey] = useState("1"); // Default open for better UX
  const [showModal, setShowModal] = useState(false);

  const { userdata, getuserData, signin } = useContext(Context);
  const navigate = useNavigate();

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  const balance = userdata?.UserWallet?.amount?.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }) || "0.00";

  return (
    <section className="my-account-page">
      <div className="header-section">
        <Section_Header_Bar />
      </div>

      <h1 className="page-title">My Account</h1>

      <div className="account-content">
        <div className="balance-card-wrapper">
          <Accordion activeKey={activeKey} onSelect={handleToggle} flush>
            <Accordion.Item eventKey="0" className="balance-card px-3 pb-4">
              <Accordion.Header className="balance-header  w-full max-md:!p-0">
                <div className="flex  justify-between w-full px-3 gap-5 max-md:flex-col">
                <div className="balance-main max-md:!text-xs">
                  <div className="balance-display">
                    <span className="currency max-md:!text-3xl">$</span>
                    <span className="amount max-md:!text-3xl">{balance}</span>
                  </div>
                  <p className="balance-label">Available Balance</p>
                </div>

                <div className="action-buttons flex flex-col w-full">
                  <Orange_White_Border_Btn
                    btn_name="Trade"
                    onClick={() => navigate("/trade")}
                    className="action-btn trade-btn text-black hover:!text-white"
                  />
                  <Blue_White_Gradient_Btn
                    btn_name="Deposit"
                    onClick={() => navigate("/deposit")}
                    className="action-btn deposit-btn"
                  />
                  <Blue_White_Gradient_Btn
                    btn_name="Withdraw"
                    onClick={() => navigate("/withdrawal")}
                    className="action-btn withdraw-btn"
                  />
                </div>
                </div>
              </Accordion.Header>

              <Accordion.Body className="balance-details !rounded-3xl">
                <div className="password-section !w-full">
                  <button
                    className="password-change-btn !w-full"
                    onClick={() => setShowModal(true)}
                  >
                    <FontAwesomeIcon icon={faPencil} className="btn-icon" />
                    Change Trading Password
                  </button>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>

        <div className="footer-section">
          <Inner_Footer_Text_Component />
        </div>
      </div>

      <Change_Trading_Password_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </section>
  );
};

export default My_Account;